// src/services/api/admin.js
// Admin panel API calls.

import { fetchWithCommonHeaders, API_URL } from './helpers';

export const fetchAdminPanelData = async (token) => {
    const response = await fetchWithCommonHeaders(`${API_URL}v2/adminview`, {
        method: 'POST',
        token,
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
    }

    return response.json();
};
